import isAlpha from 'validator/lib/isAlpha';
import msg from '../getErrorMsg';

export default (input, params, context) => {
  if (!input.value) return false;

  if (params.strictLatinOnly) {
    for (let char of input.value) {
      if (char.toLowerCase() !== char.toUpperCase()) {
        if (!/[A-Za-z]/.test(char)) {
          return msg(context, params.error ? params.error : 'notAlpha');
        }
      }
    }
  } else {
    params.ignore = '()' + (params.ignore ? params.ignore : '');

    // Include special charters to ignore in the regex
    if (params.forAemi === true) {
      params.ignore += '‘’\'"';
    }
    params.ignore += '`&';

    // Add line breaks if ignoreRowWrap = true
    if (params.ignoreRowWrap === true) {
      params.ignore += '\n\r';
    }

    // Unescape regex special characters
    let regexPattern = new RegExp('[' + params.ignore.replace(/[.*+?^${}()|[\]\\']/g, '\\$&') + ']', 'g');

    // Remove all characters that are not in the ignore list
    let cleanedText = input.value.replace(regexPattern, '');
    if (cleanedText.length === 0) return false;

    if (!input?.disabled && !isAlpha(input.value, params.locale, { ignore: params.ignore })) {
      return msg(context, params.error ? params.error : 'notAlpha');
    }

    return false;
  }
};
